import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute(
  '/(protected)/workspaces/$workspaceId/approvals',
)({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/workspaces/$workspaceId/policies',
      params: { workspaceId: params.workspaceId },
      replace: true,
    })
  },
})
